import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCog,
  faGamepad,
  faHandHoldingUsd,
  faWallet,
  faChartLine,
  faServer,
  faCoins,
} from '@fortawesome/free-solid-svg-icons';
import styles from './HomePage.module.css';

const HomePage = () => {
  const { t } = useTranslation();

  const cards = [
    {
      key: 'wallet',
      className: styles.cardWallet,
      icon: faWallet,
      title: t('why_choose'),
      items: [
        { icon: faChartLine, text: t('create_address') },
        { icon: faCoins, text: t('send_funds') },
        { icon: faWallet, text: t('view_balance') },
        { icon: faChartLine, text: t('recent_transactions') },
        { icon: faServer, text: t('manage_utxos') },
      ],
    },
    {
      key: 'nodes',
      className: styles.cardNodes,
      icon: faServer,
      title: t('smartnode_management'),
      items: [
        { icon: faCog, text: t('add_remove_nodes') },
        { icon: faChartLine, text: t('track_performance') },
        { icon: faCoins, text: t('manage_rewards') },
        { icon: faCog, text: t('optimize_nodes') },
        { icon: faServer, text: t('view_node_stats') },
      ],
    },
    {
      key: 'staking',
      className: styles.cardStaking,
      icon: faCoins,
      title: t('staking'),
      items: [
        { icon: faHandHoldingUsd, text: t('stake_tokens') },
        { icon: faCoins, text: t('earn_rewards') },
        { icon: faChartLine, text: t('track_stakes') },
        { icon: faHandHoldingUsd, text: t('manage_rewards') },
        { icon: faChartLine, text: t('view_stake_performance') },
      ],
    },
    {
      key: 'games',
      className: styles.cardGames,
      icon: faGamepad,
      title: t('games'),
      items: [
        { icon: faGamepad, text: t('play_games') },
        { icon: faCoins, text: t('earn_rewards_games') },
        { icon: faChartLine, text: t('track_progress') },
        { icon: faGamepad, text: t('compete_in_challenges') },
        { icon: faChartLine, text: t('achieve_high_scores') },
      ],
    },
  ];

  return (
    <main className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.title}>{t('welcome')}</h1>
        <p className={styles.description}>{t('description')}</p>
      </header>

      <section className={styles.cardsGrid} aria-label={t('why_choose')}>
        {cards.map(({ key, className, icon, title, items }) => (
          <article key={key} className={`${styles.card} ${className}`} tabIndex={0}>
            <div className={styles.cardIcon} aria-hidden>
              <FontAwesomeIcon icon={icon} />
            </div>
            <h2 className={styles.cardTitle}>{title}</h2>
            <ul className={styles.cardList}>
              {items.map((it, i) => (
                <li key={`${key}-${i}`}>
                  <FontAwesomeIcon icon={it.icon} />
                  <span>{it.text}</span>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </section>
    </main>
  );
};

export default HomePage;
